import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from './AuthContext';
import styles from './UserMenu.module.css';

function getInitials(user) {
  const name = user?.user_metadata?.full_name || user?.email || '?';
  return name.split(/[\s@]+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

function getDisplayName(user) {
  return user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User';
}

export default function UserMenu() {
  const { user, signOut } = useAuth();
  const [open, setOpen]   = useState(false);
  const ref               = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSignOut = async () => {
    setOpen(false);
    await signOut();
  };

  return (
    <div className={styles.wrap} ref={ref}>
      <button className={styles.avatar} onClick={() => setOpen(!open)} title={getDisplayName(user)}>
        {getInitials(user)}
      </button>

      {open && (
        <div className={styles.dropdown}>
          {/* User info */}
          <div className={styles.userInfo}>
            <div className={styles.avatarLg}>{getInitials(user)}</div>
            <div>
              <div className={styles.userName}>{getDisplayName(user)}</div>
              <div className={styles.userEmail}>{user?.email}</div>
            </div>
          </div>

          <div className={styles.divider} />

          {/* Menu items */}
          <button className={styles.menuItem} onClick={() => setOpen(false)}>
            <span>🔍</span> Search history
          </button>
          <button className={styles.menuItem} onClick={() => setOpen(false)}>
            <span>❤️</span> Saved products
          </button>
          <button className={styles.menuItem} onClick={() => setOpen(false)}>
            <span>🔔</span> Price alerts
          </button>

          <div className={styles.divider} />

          <button className={`${styles.menuItem} ${styles.signOut}`} onClick={handleSignOut}>
            <span>👋</span> Sign out
          </button>
        </div>
      )}
    </div>
  );
}
